import React, { Component } from 'react';
import { Container } from 'mdbreact';
import 'mdbreact/dist/css/mdb.css';
import CompanyDevice from '../Services/CompanyDeviceService/companyDeviceService';
import '../log/log.css';
import OnlineImg from '../Images/online.png';
import OfflineImg from '../Images/offline.png';
import WarningTriangle from '../Images/triangle.png';
import DangerTriangle from '../Images/triangle-danger.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock, faUserTimes, faUserSecret, faChevronDown, faTrash, faAdjust, faExclamationTriangle, faEye, faInfo, faCheck, faTimes, faCircleNotch, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Badge, TabContent, TabPane, Card, Row, Col, Nav, NavItem, NavLink } from 'reactstrap';
import CommandService from '../Services/Command/command';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from 'react-emotion';
// First way to import
import { ClipLoader } from 'react-spinners';
import MainLayout from '../layout/layout';
import { Redirect } from 'react-router-dom';
import RolesType from '../utils/roles';
import CommandType from '../utils/CommandType';
import CompanyTaskService from '../Services/CompanyTaskService/companyTaskService';
//import {Tabs, Tab} from 'react-bootstrap-tabs';
import './realtime.css';
import CompanyVersions from '../Services/XenioUpdates/xenioUpdates';
import classnames from 'classnames';
import BlockUi from 'react-block-ui';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { DateUtils } from "react-day-picker";
import 'react-block-ui/style.css';

//Device tool menu


const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class RealTime extends Component {
    constructor(props) {
        super();
        this.state = {
            Data: { DataPending: false, DataValue: null },
            CompanyDevice: { CompanyDevicePending: false, CompanyDeviceData: [] },
            Filter: {
                FilterCompanyCode: "",
                FilterDeviceSerialNumber: "",
                FilterUpdate: 0,
                FilterVersion: "",
                Filterstartdate: null,
                Filterenddate: null,
            },
            SelectCompanyCode: "",
            ID: null,
            modal: {
                warning: false, id: null, success: false, info: false, info2: false, resend: false
                , adjustSensors: {
                    active: false,
                    deviceId: null,
                    companyCode: null,
                    sensors: {
                        Pin: { selected: false, code: 1 },
                        Card: { selected: false, code: 2 },
                        Fingerprint: { selected: false, code: 3 }
                    }
                }
            },
            Button: <a className="btn btn-warning">OK</a>,
            loading: false,
            Punchloading: false,
            DeviceSerialNumber: "",
            ViewCompanyCode: "",
            CommandTypeList: [],
            CommandTypeDetailsList: [],
            CommandTypeDetailsRestriction: [],
            isAutenticated: true,
            SelectType: "",
            SelectVersionName: "",
            TypeList: [],
            VersionNameList: [],
            key: 2,
            activeTab: '1',
            DataCommandList: [],
            validateSelect: "",
            validateSelect2: "",
            collapsedMenus: []
        };
        //this.state.modal.adjustSensors
        this.companyCodeValue = this.companyCodeValue.bind(this);
        this.serialNumberValue = this.serialNumberValue.bind(this);
        this.getID = this.getID.bind(this);
        this.toggleWarning = this.toggleWarning.bind(this);
        this.hanldeKeyPress = this.hanldeKeyPress.bind(this);
        this.companyCodeSelectValue = this.companyCodeSelectValue.bind(this);
        this.toggleInfo = this.toggleInfo.bind(this);
        this.toggleInfo2 = this.toggleInfo2.bind(this);
        this.handleChangeVersion = this.handleChangeVersion.bind(this);
        this.handleChangeVersionName = this.handleChangeVersionName.bind(this);
        this.hanldeUpdate = this.hanldeUpdate.bind(this);
        this.toggleResend = this.toggleResend.bind(this);
        this.toggleAdjustSensors = this.toggleAdjustSensors.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    // Centralized error handler
    handleApiError = (error, that) => {
        const errorState = {
            loading: false,
            modal: {
                warning: false, 
                id: null, 
                adjustSensors: {
                    active: false,
                    deviceId: null,
                    companyCode: null,
                    sensors: {
                        Pin: { selected: false, code: 1 },
                        Card: { selected: false, code: 2 },
                        Fingerprint: { selected: false, code: 3 }
                    }
                }
            }
        };

        if (error.response) {
            if (error.response.data && error.response.data.Message === "500") {
                toast.error("Error Data Base(Error: 500)", { className: { opacity: 0.8 } });
            } else if (error.response.data === "NoDB") {
                toast.error("Company Code doesn't exist!", { className: { opacity: 0.8 } });
            } else if (error.response.data === "NotReseller") {
                toast.error("This User does not have permission!", { className: { opacity: 0.8 } });
            } else if (error.response.data && error.response.data.Message === "400") {
                toast.error("API Error for Reseller", { className: { opacity: 0.8 } });
            } else if (error.response.status === 401) {
                sessionStorage.clear();
                that.setState({ isAutenticated: false });
            }
        } else {
            toast.error("Code Error", { className: { opacity: 0.8 } });
        }
        return errorState;
    }
    wait = 0;
    startdate;
    enddate;
    getStartDate(day) {

        var isDate = DateUtils.isDate(day);
        var temp = "";
        if (isDate && day) {

            if (day) {
                let newstartDate = new Date(day);
                temp = newstartDate.getFullYear() + "-" + (newstartDate.getMonth() + 1) + "-" + newstartDate.getDate();
            }
            else {
                temp = null;

            }
            let stateCopy = Object.assign({}, this.state);
            stateCopy.Filter.Filterstartdate = temp;
            stateCopy.Filter.Filterenddate = this.state.Filter.Filterenddate;
            this.setState(stateCopy);
        } else {
            let stateCopy = Object.assign({}, this.state);
            stateCopy.Filter.Filterstartdate = "";
            stateCopy.Filter.Filterenddate = this.state.Filter.Filterenddate;
            this.setState(stateCopy);
        }
    }
    getEndDate(day) {

        var isDate = DateUtils.isDate(day);
        var temp = "";
        if (isDate && day) {
            if (day) {
                let newendDate = new Date(day);
                temp = newendDate.getFullYear() + "-" + (newendDate.getMonth() + 1) + "-" + newendDate.getDate();
            }
            else {
                temp = null;
            }
            let stateCopy = Object.assign({}, this.state);
            stateCopy.Filter.Filterstartdate = this.state.Filter.Filterstartdate;
            stateCopy.Filter.Filterenddate = temp;
            this.setState(stateCopy);

        } else {
            let stateCopy = Object.assign({}, this.state);
            stateCopy.Filter.Filterstartdate = this.state.Filter.Filterstartdate;
            stateCopy.Filter.Filterenddate = "";
            this.setState(stateCopy);
        }
    }
    companyCodeValue(e) {
        e.preventDefault();
        let stateCopy = Object.assign({}, this.state);
        stateCopy.Filter.FilterCompanyCode = e.target.value;
        this.setState(stateCopy);
    }
    handleChangeVersion(event) {
        var value = event.target.value;
        this.setState({
            SelectType: value,
            SelectVersionName: "",
            validateSelect: value,
            validateSelect2: value
        }, () => this.getAllVersionByType());
    }
    handleChangeVersionName(event) {
        var value = event.target.value;
        this.setState({
            SelectVersionName: value
        }, () => console.log());
    }
    hanldeUpdate(e) {
        e.preventDefault();
        let stateCopy = Object.assign({}, this.state);
        stateCopy.SelectUpdateID = e.target.value;
        stateCopy.Filter.FilterUpdate = e.target.value;
        this.setState(stateCopy);
    }
    getAllType() {
        var CompanyCode = this.state.ViewCompanyCode;
        let dataResult = CompanyVersions.getAllUpdateType(CompanyCode);
        var that = this;
        let stateCopy = Object.assign({}, that.state);
        var TypeListResult = [];
        dataResult.then(function (data) {
            data.data.map((elem) => {
                TypeListResult.push({ ID: elem.ID, Name: elem.Name })
                return console.log();
            });
            stateCopy.TypeList = TypeListResult;
            that.setState(stateCopy);

        }).catch((status, err) => {

            toast.error("Error Data Base!", {
                className: {
                    opacity: 0.8
                }
            });
        });
    }
    getAllVersionByType() {
        var CompanyCode = this.state.ViewCompanyCode;
        var UpdateID = this.state.SelectType;
        if (UpdateID !== "" && UpdateID !== undefined && UpdateID !== null) {
            var DataUpdateTypeResult = CompanyVersions.getAllUpdateVersion(CompanyCode, UpdateID);
            var that = this;
            DataUpdateTypeResult.then(function (data) {
                that.setState({
                    VersionNameList: data.data
                });
            }).catch((error) => {
                if (error.response) {
                    if (error && error.response && error.response.data.Message === "500") {
                        toast.error("Error Data Base(Error: 500)", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error && error.response && error.response.data === "NoDB") {
                        toast.error("Company Code dosen't exist!", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error && error.response && error.response.data === "NotReseller") {
                        toast.error("This User does not have permission!", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error && error.response && error.response.data.Message === "400") {
                        toast.error("API Error for Reseller", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error.response.status === 401) {
                        sessionStorage.setItem("user", '');
                        sessionStorage.setItem("token", '');
                        sessionStorage.setItem("rol", '');
                        sessionStorage.setItem("email", '');
                        sessionStorage.clear();
                        this.setState({ isAutenticated: false },
                            () => {
                                this.forceUpdate();
                            })
                    }
                } else {
                    toast.error("Code Error", {
                        className: {
                            opacity: 0.8
                        }
                    });
                }
            });
        } else {
            this.setState({
                VersionNameList: []
            }, () => console.log());
        }
    }
    companyCodeSelectValue(e) {
        e.preventDefault();
        let stateCopy = Object.assign({}, this.state);
        stateCopy.SelectCompanyCode = e.target.value;
        this.setState(stateCopy);
    }
    hanldeKeyPress(e) {
        //e.preventDefault();
        var CompanyCode = this.state.Filter.FilterCompanyCode;
        var DeviceID = this.state.Filter.FilterDeviceSerialNumber;
        if (e.keyCode === 13) {
            if (!CompanyCode && !DeviceID) {
                toast.error("Company Code can't be empty!", {
                    className: {
                        opacity: 0.8
                    }
                });
                return false;
            }
            this.getCompanyDeviceData();
        }
        //this.getAllType(); 
    }
    toggleWarning(id) {
        this.setState({
            modal: {
                warning: !this.state.modal.warning, id: id, success: false, adjustSensors: {
                    active: false,
                    deviceId: null,
                    companyCode: null,
                    sensors: {
                        Pin: { selected: false, code: 1 },
                        Card: { selected: false, code: 2 },
                        Fingerprint: { selected: false, code: 3 }
                    }
                }
            },
        });
    }
    toggleResend(id) {
        this.setState({
            modal: {
                warning: false, id: null, success: false, info: false, info2: false, resend: !this.state.modal.resend, adjustSensors: {
                    active: false,
                    deviceId: null,
                    companyCode: null,
                    sensors: {
                        Pin: { selected: false, code: 1 },
                        Card: { selected: false, code: 2 },
                        Fingerprint: { selected: false, code: 3 }
                    }
                }
            },
            Filter: { Filterstartdate: "", Filterenddate: "", FilterCompanyCode: this.state.Filter.FilterCompanyCode, FilterDeviceSerialNumber: this.state.Filter.FilterDeviceSerialNumber }
        });
    }
    toggleAdjustSensors(id, companyCode) {
        this.setState({
            modal: {
                warning: false, id: id, success: false, info: false, info2: false, adjustSensors: {
                    active: !this.state.modal.adjustSensors.active,
                    deviceId: id,
                    companyCode: companyCode,
                    sensors: {
                        Pin: { selected: false, code: 1 },
                        Card: { selected: false, code: 2 },
                        Fingerprint: { selected: false, code: 3 }
                    }
                }
            },

        });
    }
    toggleInfo2(id, CompanyCode) {
        this.setState({
            modal: {
                warning: false, id: id, success: false, info: false, info2: !this.state.modal.info2, adjustSensors: {
                    active: false,
                    deviceId: null,
                    companyCode: null,
                    sensors: {
                        Pin: { selected: false, code: 1 },
                        Card: { selected: false, code: 2 },
                        Fingerprint: { selected: false, code: 3 }
                    }
                }
            },
            DeviceSerialNumber: id,
            ViewCompanyCode: CompanyCode,
            SelectType: "",
            SelectVersionName: "",
            activeTab: "1"
        });
    }
    toggleInfo(id, CompanyCode) {
        this.setState({
            modal: {
                warning: false, id: id, success: false, info: !this.state.modal.info, adjustSensors: {
                    active: false,
                    deviceId: null,
                    companyCode: null,
                    sensors: {
                        Pin: { selected: false, code: 1 },
                        Card: { selected: false, code: 2 },
                        Fingerprint: { selected: false, code: 3 }
                    }
                }
            },
            DeviceSerialNumber: id,
            ViewCompanyCode: CompanyCode
        });
    }
    getCommandPendindByDevice() {
        var that = this;
        var CompanyCode = this.state.ViewCompanyCode;
        var DeviceSerialNumber = this.state.DeviceSerialNumber;
        var Email = sessionStorage.getItem('email');
        var DataResult = CommandService.getCommandPendindByDevice(CompanyCode, DeviceSerialNumber, Email);
        DataResult.then(function (data) {
            that.setState({
                loading: false,
                CommandTypeList: data.data || [],
            });
        }).catch((error) => {
            that.setState({
                loading: false,
                CommandTypeList: [],
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    getCommandPendindDetails() {

        var that = this;
        var CompanyCode = this.state.ViewCompanyCode;
        var DeviceSerialNumber = this.state.DeviceSerialNumber;
        var Email = sessionStorage.getItem('email');
        this.setState({
            loading: true,
        });
        var DataResult = CommandService.getCommandPendDetails(CompanyCode, DeviceSerialNumber, Email);
        DataResult.then(function (data) {
            that.setState({
                loading: false,
                CommandTypeDetailsList: data.data.list || [],
                CommandTypeDetailsRestriction: data.data.restriction || null,
            });
        }).catch((error) => {
            that.setState({
                loading: false,
                CommandTypeDetailsList: [],
                CommandTypeDetailsRestriction: []
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    that.setState({ isAutenticated: false },
                        () => {
                            that.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    setOperation(e, id, CompanyCode, operations) {
        if (operations === "DELETE") {
            this.setState({
                Button: <a className="btn btn-warning" onClick={(e) => { this.DeletePending(e, id, CompanyCode) }}>OK</a>,
                loading: false
            });
            this.toggleWarning(id);
        } else if (operations === "ADD") {
            this.setState({
                Button: <a className="btn btn-warning" onClick={(e) => { this.SyncTime(e, id, CompanyCode) }}>OK</a>,
                loading: false
            });
            this.toggleWarning(id);
        } else if (operations === "Empty_User") {
            this.setState({
                Button: <a className="btn btn-warning" onClick={(e) => { this.EmptyUser(e, id, CompanyCode) }}  >OK</a>,
                loading: false
            });
            this.toggleWarning(id);
        } else if (operations === "Take_Managers") {
            this.setState({
                Button: <a className="btn btn-warning" onClick={(e) => { this.TakeManagers(e, id, CompanyCode) }}  >OK</a>,
                loading: false
            });
            this.toggleWarning(id);
        } else if (operations === "Clean_Cache") {
            this.setState({
                Button: <a className="btn btn-warning" onClick={(e) => { this.CleanCache(e, id, CompanyCode) }}  >OK</a>,
                loading: false
            });
            this.toggleWarning(id);
        } else if (operations === "Clean_Restriction") {
            this.setState({
                Button: <a className="btn btn-warning" onClick={(e) => { this.CleanRestriction(e, id, CompanyCode) }}  >OK</a>,
                loading: false
            });
            this.toggleWarning(id);
        } else if (operations === "Enable_Sync") {
            this.setState({
                Button: <a className="btn btn-warning" onClick={(e) => { this.EnableSync(e, id, CompanyCode) }}  >OK</a>,
                loading: false
            });
            this.toggleWarning(id);
        } else if (operations === "Disable_Sync") {
            this.setState({
                Button: <a className="btn btn-warning" onClick={(e) => { this.DisableSync(e, id, CompanyCode) }}  >OK</a>,
                loading: false
            });
            this.toggleWarning(id);
        } else if (operations === "Clean_DB") {
            this.setState({
                Button: <a className="btn btn-warning" onClick={(e) => { this.CleanDB(e, id, CompanyCode) }}  >OK</a>,
                loading: false
            });
            this.toggleWarning(id);
        } else if (operations === "Resend_Timelog") {
            this.setState({
                Button: <a className="btn btn-success" onClick={(e) => { this.ResendTimelog(e, id, CompanyCode) }}  >OK</a>,
                loading: false
            });
            this.toggleResend(id);
        } else if (operations === "VIEW") {
            this.toggleInfo2(id, CompanyCode);
            this.setState({
                DeviceSerialNumber: id,
                ViewCompanyCode: CompanyCode,
                VersionNameList: [],
                loading: true
            }, () => {
                this.getCommandPendindDetails();
                //this.getCommandPendindByDevice();
            });
        } else if (operations === "DELALL") {
            this.setState({
                loading: false,
                DeviceSerialNumber: id,
                ViewCompanyCode: CompanyCode
            }, () => this.getCommandPendindByDevice());
            this.toggleInfo(id, CompanyCode);
        } else if (operations === "DEL") {
            this.setState({
                Button: <a className="btn btn-warning" onClick={(e) => { this.DeleteRestriction(e, id, CompanyCode) }}>OK</a>,
                loading: false
            });
            this.toggleWarning(id);
        }
        else if (operations === "ADJUST_SENSORS") {
            this.setState({
                Button: <a className="btn btn-success" onClick={(e) => { this.AdjustSensors(e) }}  >OK</a>,
                loading: false
            });
            this.toggleAdjustSensors(id, CompanyCode);
        }
    }
    serialNumberValue(e) {
        e.preventDefault();
        let stateCopy = Object.assign({}, this.state);
        stateCopy.Filter.FilterDeviceSerialNumber = e.target.value;
        this.setState(stateCopy);
    }
    componentDidMount() {

    }
    getCompanyDeviceData() {
        var email = sessionStorage.getItem('email');
        this.setState({
            CompanyDevice: { CompanyDevicePending: true, CompanyDeviceData: [] }
        });
        if ((this.state.Filter.FilterCompanyCode !== "" && this.state.Filter.FilterCompanyCode !== null) ||
            (this.state.Filter.FilterDeviceSerialNumber !== "" && this.state.Filter.FilterDeviceSerialNumber !== null)) {
            var dataResult = CompanyDevice.getAllCompanyDevice(this.state.Filter.FilterCompanyCode, this.state.Filter.FilterDeviceSerialNumber, email);
            var DataSatusResult = CompanyDevice.getStatusDevice(this.state.Filter.FilterCompanyCode, this.state.Filter.FilterDeviceSerialNumber, email);
            var DataCommandPendResult = CommandService.getCommand(this.state.Filter.FilterCompanyCode, this.state.Filter.FilterDeviceSerialNumber, email);
        }
        var that = this;
        var DataFinal1 = [];
        var DataFinal2 = [];
        var DataFinal = [];
        var DataCommand = [];
        Promise.all([dataResult, DataSatusResult, DataCommandPendResult]).then(values => {


            if (values[0].data === "" || values[0].data === null || values[0].data === undefined) {
                that.setState({
                    CompanyDevice: { CompanyDevicePending: false, CompanyDeviceData: [] }
                });
                return false;
            }
            if (values[0].data === "NoDB" || values[1].data === "NoDB" || values[2].data === "NoDB") {
                that.setState({
                    CompanyDevice: { CompanyDevicePending: false, CompanyDeviceData: [] }
                });
                toast.error("Company Code or Serial Number doesn't exist!", {
                    className: { opacity: 0.8 }
                });
                return false;
            }
            if (values[0].data === "Empty" || values[1].data === "Empty" || values[2].data === "Empty") {
                that.setState({
                    CompanyDevice: { CompanyDevicePending: false, CompanyDeviceData: [] }
                });
                toast.error("Company Code and Serial Number field should not be empty!", {
                    className: { opacity: 0.8 }
                });
                return false;
            }
            if (values[0].data === "NotFound" || values[1].data === "NotFound" || values[2].data === "NotFound") {

                that.setState({
                    CompanyDevice: { CompanyDevicePending: false, CompanyDeviceData: [] }
                });

                toast.error("User does not have permission for this Company!", {
                    className: {
                        opacity: 0.8
                    }
                });
                return false;
            }
            if (values[2].data) {
                values[0].data.forEach((item) => {

                    let statuFinal = values[1].data.find(s => s.DeviceSerialNumber === item.DeviceSerialNumber);

                    //Total pending
                    let TotalPendingN = 0;
                    let ObjPending = values[2].data.filter(s => s.DeviceSerialNumber === item.DeviceSerialNumber && s.Pending === 1);
                    TotalPendingN = (ObjPending !== null && ObjPending !== undefined) ? parseInt(ObjPending.length, 10) + parseInt(TotalPendingN, 10) : 0;
                    let statuss = "";

                    if (statuFinal) {
                        statuss = (statuFinal.Online === true) ? <img src={OnlineImg} title="Online" alt="" />
                            : <img src={OfflineImg} title="Offline" alt="" />;
                    } else {
                        statuss = <img src={WarningTriangle} title="Master Sync Issue" alt="" width="20px" />;
                    }
                    DataFinal1.push({
                        id: item.id, CompanyCode: item.CompanyCode, DeviceSerialNumber: item.DeviceSerialNumber,
                        AccessControl: item.AccessControl, Status: statuss, Pending: TotalPendingN,
                        LastConnected: statuFinal ? statuFinal.LastConnected : item.LastConnected,
                        LastDisconnected: statuFinal ? statuFinal.LastDisconnected : item.LastDisconnected
                    });

                })
                //child list
                if (this.state.Filter.FilterCompanyCode !== null && this.state.Filter.FilterCompanyCode !== "" && this.state.Filter.FilterCompanyCode !== undefined) {
                    values[1].data.forEach((item) => {
                        let statuFinal = values[0].data.find(s => s.DeviceSerialNumber === item.DeviceSerialNumber);
                        //Total pending
                        let TotalPendingN = 0;
                        let ObjPending = values[2].data.filter(s => s.DeviceSerialNumber === item.DeviceSerialNumber && s.Pending === 1);
                        TotalPendingN = (ObjPending !== null && ObjPending !== undefined) ? parseInt(ObjPending.length, 10) + parseInt(TotalPendingN, 10) : 0;
                        let statuss = "";
                        if (statuFinal) {
                            statuss = (statuFinal.Online === true) ? <img src={OnlineImg} title="Online" alt="" /> : <img src={OfflineImg} title="Offline" alt="" />;
                        } else {
                            statuss = <img src={DangerTriangle} title="Company Sync Issue" alt="" width="20px" />;
                        }
                        let DeleteList = DataFinal1.find(s => s.DeviceSerialNumber === item.DeviceSerialNumber);
                        if (DeleteList === undefined) {
                            DataFinal2.push({
                                id: item.id, CompanyCode: item.companyCode, DeviceSerialNumber: item.DeviceSerialNumber,
                                AccessControl: item.AccessControl, Status: statuss, Pending: TotalPendingN,
                                LastConnected: statuFinal ? statuFinal.LastConnected : item.LastConnected,
                                LastDisconnected: statuFinal ? statuFinal.LastDisconnected : item.LastDisconnected
                            });
                        }
                    })
                }
                values[2].data.forEach((item) => {
                    DataCommand.push({ DeviceSerialNumber: item.DeviceSerialNumber, CommandType: item.CommandType, Result: item.Result, Settled: item.Settled });
                })
                DataFinal = DataFinal1.concat(DataFinal2);
                DataFinal.sort(function (a, b) {
                    return (b.Pending - a.Pending)
                });
                //var Data_Com = DataCommand.find(x=>x.CommandType === 200002);
                var Data_Com = DataCommand.sort(function (a, b) {
                    return (a.Settled < b.Settled) ? 1 : ((b.Settled < a.Settled) ? -1 : 0)
                });;

                //DataCommandResult = Data_Com

                //console.log(Data_Com)

                let stateCopy = Object.assign({}, that.state);
                stateCopy.CompanyDevice.CompanyDeviceData = DataFinal;
                stateCopy.DataCommandList = Data_Com;
                stateCopy.CompanyDevice.CompanyDevicePending = false;
                that.setState(stateCopy, () => {
                    this.getAllType();
                });
            }
        }).catch((error) => {
            that.setState({
                CompanyDevice: { CompanyDevicePending: false, CompanyDeviceData: [] }
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    getID(id) {
        this.setState({
            ID: id
        }, console.log());
    }
    DeletePending(e, id, CompanyCode) {
        e.preventDefault();
        var email = sessionStorage.getItem('email');
        this.setState({
            loading: true,
            Button: <a className="btn btn-warning disabled" onClick={(e) => { this.TakeManagers(e) }} disabled >OK</a>
        });
        var that = this;
        var result = CommandService.DeleteCommandPending(id, CompanyCode, email);
        result.then(function (data) {
            if (data.data === "OK") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    Button: <a className="btn btn-warning" onClick={(e) => { this.TakeManagers(e) }}  >OK</a>,
                    loading: false
                });
                that.getCompanyDeviceData();
                toast.success("Command Delete!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "AuditError") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    Button: <a className="btn btn-warning" onClick={(e) => { this.TakeManagers(e) }}  >OK</a>,
                    loading: false
                });
                toast.error("Audit Error!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "Empty") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    Button: <a className="btn btn-warning" onClick={(e) => { this.TakeManagers(e) }}  >OK</a>,
                    loading: false
                });
                that.getCompanyDeviceData();
                toast.error("Not Command Pending for this Device!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch((error) => {
            that.setState({
                modal: {
                    warning: false, id: null, adjustSensors: {
                        active: false,
                        deviceId: null,
                        companyCode: null,
                        sensors: {
                            Pin: { selected: false, code: 1 },
                            Card: { selected: false, code: 2 },
                            Fingerprint: { selected: false, code: 3 }
                        }
                    }
                },
                Button: <a className="btn btn-warning" onClick={(e) => { this.TakeManagers(e) }}  >OK</a>,
                loading: false
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    DeleteRestriction(e, id, CompanyCode) {
        e.preventDefault();
        var email = sessionStorage.getItem('email');
        this.setState({
            loading: true,
            Button: <a className="btn btn-warning disabled" onClick={(e) => { this.DeleteRestriction(e) }} disabled >OK</a>
        });
        var that = this;
        var result = CommandService.DeleteRestriction(id, CompanyCode, email);
        result.then(function (data) {
            if (data.data === "OK") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    Button: <a className="btn btn-warning" onClick={(e) => { this.DeleteRestriction(e) }}  >OK</a>,
                    loading: false
                });
                that.getCommandPendindDetails();
                toast.success("Cleaned Restriction Successfully!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch((error) => {
            that.setState({
                modal: {
                    warning: false, id: null, adjustSensors: {
                        active: false,
                        deviceId: null,
                        companyCode: null,
                        sensors: {
                            Pin: { selected: false, code: 1 },
                            Card: { selected: false, code: 2 },
                            Fingerprint: { selected: false, code: 3 }
                        }
                    }
                },
                Button: <a className="btn btn-warning" onClick={(e) => { this.DeleteRestriction(e) }}  >OK</a>,
                loading: false
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    SyncTime(e, id, CompanyCode) {

        let newstartDate = new Date();
        let startdate = newstartDate.getFullYear() + "-" + (newstartDate.getMonth() + 1) + "-" + newstartDate.getDate();
        let DeviceID = 0;
        let DeviceSerialNumber = id;
        let CommandType = 3;
        let Pending = 1;
        let Result = null;
        let Settled = startdate;
        var email = sessionStorage.getItem('email');
        this.setState({
            loading: true,
            Button: <a className="btn btn-warning disabled" onClick={(e) => { this.SyncTime(e) }} disabled >OK</a>
        });
        var that = this;
        var addResult = CommandService.AddCommandPending(DeviceID, DeviceSerialNumber, CommandType, Pending, Result, Settled, CompanyCode, email);
        addResult.then(function (data) {
            if (data.data === "OK") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { this.SyncTime(e) }} >OK</a>
                });
                that.getCompanyDeviceData();
                toast.success("Command Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "No") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { this.SyncTime(e) }} >OK</a>
                });
                that.getCompanyDeviceData();
                toast.error("Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "AuditError") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { this.SyncTime(e) }} >OK</a>
                });
                that.getCompanyDeviceData();
                toast.error("Audit Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch((error) => {
            that.setState({
                modal: {
                    warning: false, id: null, adjustSensors: {
                        active: false,
                        deviceId: null,
                        companyCode: null,
                        sensors: {
                            Pin: { selected: false, code: 1 },
                            Card: { selected: false, code: 2 },
                            Fingerprint: { selected: false, code: 3 }
                        }
                    }
                },
                loading: false,
                Button: <a className="btn btn-warning" onClick={(e) => { this.SyncTime(e) }} >OK</a>
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    EmptyUser(e, id, CompanyCode) {

        let newstartDate = new Date();
        let startdate = newstartDate.getFullYear() + "-" + (newstartDate.getMonth() + 1) + "-" + newstartDate.getDate();
        let DeviceID = 0;
        let DeviceSerialNumber = id;
        let CommandType = 12;
        let Pending = 1;
        let Result = null;
        let Settled = startdate;
        var email = sessionStorage.getItem('email');
        this.setState({
            loading: true,
            Button: <a className="btn btn-warning disabled" onClick={(e) => { this.EmptyUser(e) }} disabled >OK</a>
        });
        var that = this;
        var addResult = CommandService.AddCommandPending(DeviceID, DeviceSerialNumber, CommandType, Pending, Result, Settled, CompanyCode, email);
        addResult.then(function (data) {
            if (data.data === "OK") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { this.EmptyUser(e) }}  >OK</a>
                });
                that.getCompanyDeviceData();
                toast.success("Command Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "No") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { this.EmptyUser(e) }}  >OK</a>
                });
                that.getCompanyDeviceData();
                toast.error("Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "AuditError") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { this.EmptyUser(e) }}  >OK</a>
                });
                that.getCompanyDeviceData();
                toast.error("Audit Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch((error) => {
            that.setState({
                modal: {
                    warning: false, id: null, adjustSensors: {
                        active: false,
                        deviceId: null,
                        companyCode: null,
                        sensors: {
                            Pin: { selected: false, code: 1 },
                            Card: { selected: false, code: 2 },
                            Fingerprint: { selected: false, code: 3 }
                        }
                    }
                },
                loading: false,
                Button: <a className="btn btn-warning" onClick={(e) => { this.EmptyUser(e) }}  >OK</a>
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    TakeManagers(e, id, CompanyCode) {

        let newstartDate = new Date();
        let startdate = newstartDate.getFullYear() + "-" + (newstartDate.getMonth() + 1) + "-" + newstartDate.getDate();
        let DeviceID = 0;
        let DeviceSerialNumber = id;
        let CommandType = 10;
        let Pending = 1;
        let Result = null;
        let Settled = startdate;
        var email = sessionStorage.getItem('email');
        this.setState({
            loading: true,
            Button: <a className="btn btn-warning disabled" onClick={(e) => { this.TakeManagers(e) }} disabled >OK</a>
        });
        var that = this;
        var addResult = CommandService.AddCommandPending(DeviceID, DeviceSerialNumber, CommandType, Pending, Result, Settled, CompanyCode, email);
        addResult.then(function (data) {
            if (data.data === "OK") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { this.TakeManagers(e) }} >OK</a>
                });
                that.getCompanyDeviceData();
                toast.success("Command Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "No") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { this.TakeManagers(e) }} disabled >OK</a>
                });
                that.getCompanyDeviceData();
                toast.error("Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "AuditError") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { this.TakeManagers(e) }} disabled >OK</a>
                });
                that.getCompanyDeviceData();
                toast.error("Audit Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch((error) => {
            that.setState({
                modal: {
                    warning: false, id: null, adjustSensors: {
                        active: false,
                        deviceId: null,
                        companyCode: null,
                        sensors: {
                            Pin: { selected: false, code: 1 },
                            Card: { selected: false, code: 2 },
                            Fingerprint: { selected: false, code: 3 }
                        }
                    }
                },
                loading: false,
                Button: <a className="btn btn-warning" onClick={(e) => { this.TakeManagers(e) }} disabled >OK</a>
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    DeleteRepeatedPunches() {

        var CompanyCode = this.state.SelectCompanyCode;
        var email = sessionStorage.getItem('email');
        var that = this;
        that.setState({
            Punchloading: true
        });
        if (CompanyCode === "" || CompanyCode === null || CompanyCode === undefined) {

            that.setState({
                Punchloading: false
            });
            toast.error("Company Code can not be empty!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        var DataResult = CompanyTaskService.DeletePunches("1", CompanyCode, email);
        DataResult.then(function (data) {
            if (data.data === "OK") {
                that.setState({
                    Punchloading: false,
                });
                toast.success("Punch Deleted!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch((error) => {
            that.setState({
                Punchloading: false,
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    CleanCache(e, id, CompanyCode) {

        var email = sessionStorage.getItem('email');
        var DeviceSerialNumber = id;
        var that = this;
        this.setState({
            loading: true,
            Button: <a className="btn btn-warning disabled" onClick={(e) => { this.CleanCache(e) }} disabled >OK</a>
        });
        var addResult = CommandService.CleanCache(DeviceSerialNumber, CompanyCode, email);
        addResult.then(function (data) {
            if (data.data === "OK") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { this.CleanCache(e) }} >OK</a>
                });
                that.getCompanyDeviceData();
                toast.success("Command Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "No") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { this.CleanCache(e) }} >OK</a>
                });
                that.getCompanyDeviceData();
                toast.error("Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "AuditError") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { this.CleanCache(e) }} >OK</a>
                });
                that.getCompanyDeviceData();
                toast.error("Audit Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch((error) => {
            that.setState({
                modal: {
                    warning: false, id: null, adjustSensors: {
                        active: false,
                        deviceId: null,
                        companyCode: null,
                        sensors: {
                            Pin: { selected: false, code: 1 },
                            Card: { selected: false, code: 2 },
                            Fingerprint: { selected: false, code: 3 }
                        }
                    }
                },
                loading: false,
                Button: <a className="btn btn-warning" onClick={(e) => { this.CleanCache(e) }} >OK</a>
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    CleanRestriction(e, id, CompanyCode) {

        var email = sessionStorage.getItem('email');
        var DeviceSerialNumber = id;
        var that = this;
        this.setState({
            loading: true,
            Button: <a className="btn btn-warning disabled" onClick={(e) => { this.CleanRestriction(e) }} disabled >OK</a>
        });
        var addResult = CommandService.CleanRestriction(DeviceSerialNumber, CompanyCode, email);
        addResult.then(function (data) {
            if (data.data === "OK") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { this.CleanRestriction(e) }} >OK</a>
                });
                that.getCompanyDeviceData();
                toast.success("Cleaned Restriction Successfully!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "NO") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { this.CleanRestriction(e) }} >OK</a>
                });
                that.getCompanyDeviceData();
                toast.error("Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "AuditError") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { this.CleanRestriction(e) }} >OK</a>
                });
                that.getCompanyDeviceData();
                toast.error("Audit Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch((error) => {
            that.setState({
                modal: {
                    warning: false, id: null, adjustSensors: {
                        active: false,
                        deviceId: null,
                        companyCode: null,
                        sensors: {
                            Pin: { selected: false, code: 1 },
                            Card: { selected: false, code: 2 },
                            Fingerprint: { selected: false, code: 3 }
                        }
                    }
                },
                loading: false,
                Button: <a className="btn btn-warning" onClick={(e) => { this.CleanRestriction(e) }} >OK</a>
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    EnableSync(e, id, CompanyCode) {

        let newstartDate = new Date();
        let startdate = newstartDate.getFullYear() + "-" + (newstartDate.getMonth() + 1) + "-" + newstartDate.getDate();
        var email = sessionStorage.getItem('email');
        var DeviceSerialNumber = id;
        var DeviceID = 0;
        var CommandType = 10002;
        var Pending = 1;
        var Result = null;
        let Settled = startdate;
        var PARAM1 = 1;
        var PARAM2 = null;

        var that = this;
        this.setState({
            loading: true,
            Button: <a className="btn btn-warning disabled" onClick={(e) => { this.EnableSync(e) }} disabled >OK</a>
        });
        var addResult = CommandService.AddCommandEnableDisableSync(DeviceID, DeviceSerialNumber, CommandType, Pending, Result, Settled, PARAM1, PARAM2, CompanyCode, email);
        addResult.then(function (data) {
            if (data.data === "OK") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { that.EnableSync(e) }} >OK</a>
                });
                that.getCompanyDeviceData();
                toast.success("Enable Sync Successfully!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "No") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { that.EnableSync(e) }} >OK</a>
                });
                that.getCompanyDeviceData();
                toast.error("Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "AuditError") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { that.EnableSync(e) }} >OK</a>
                });
                that.getCompanyDeviceData();
                toast.error("Audit Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch((error) => {
            that.setState({
                modal: {
                    warning: false, id: null, adjustSensors: {
                        active: false,
                        deviceId: null,
                        companyCode: null,
                        sensors: {
                            Pin: { selected: false, code: 1 },
                            Card: { selected: false, code: 2 },
                            Fingerprint: { selected: false, code: 3 }
                        }
                    }
                },
                loading: false,
                Button: <a className="btn btn-warning" onClick={(e) => { that.EnableSync(e) }} >OK</a>
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    that.setState({ isAutenticated: false },
                        () => {
                            that.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    DisableSync(e, id, CompanyCode) {

        let newstartDate = new Date();
        let startdate = newstartDate.getFullYear() + "-" + (newstartDate.getMonth() + 1) + "-" + newstartDate.getDate();
        var email = sessionStorage.getItem('email');
        var DeviceSerialNumber = id;
        var DeviceID = 0;
        var CommandType = 10002;
        var Pending = 1;
        var Result = null;
        let Settled = startdate;
        var PARAM1 = 0;
        var PARAM2 = null;

        var that = this;
        this.setState({
            loading: true,
            Button: <a className="btn btn-warning disabled" onClick={(e) => { that.DisableSync(e) }} disabled >OK</a>
        });
        var addResult = CommandService.AddCommandEnableDisableSync(DeviceID, DeviceSerialNumber, CommandType, Pending, Result, Settled, PARAM1, PARAM2, CompanyCode, email);
        addResult.then(function (data) {
            if (data.data === "OK") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { that.DisableSync(e) }} >OK</a>
                });
                that.getCompanyDeviceData();
                toast.success("Disable Sync Successfully!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "No") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { that.DisableSync(e) }} >OK</a>
                });
                that.getCompanyDeviceData();
                toast.error("Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "AuditError") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { that.DisableSync(e) }} >OK</a>
                });
                that.getCompanyDeviceData();
                toast.error("Audit Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch((error) => {
            that.setState({
                modal: {
                    warning: false, id: null, adjustSensors: {
                        active: false,
                        deviceId: null,
                        companyCode: null,
                        sensors: {
                            Pin: { selected: false, code: 1 },
                            Card: { selected: false, code: 2 },
                            Fingerprint: { selected: false, code: 3 }
                        }
                    }
                },
                loading: false,
                Button: <a className="btn btn-warning" onClick={(e) => { that.DisableSync(e) }} >OK</a>
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    that.setState({ isAutenticated: false },
                        () => {
                            that.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    CleanDB(e, id, CompanyCode) {

        let newstartDate = new Date();
        let startdate = newstartDate.getFullYear() + "-" + (newstartDate.getMonth() + 1) + "-" + newstartDate.getDate();
        var email = sessionStorage.getItem('email');
        var DeviceSerialNumber = id;
        var DeviceID = 0;
        var CommandType = 10000;
        var Pending = 1;
        var Result = null;
        let Settled = startdate;
        var PARAM1 = null;
        var PARAM2 = null;
        var PARAM3 = null;

        var that = this;
        this.setState({
            loading: true,
            Button: <a className="btn btn-warning disabled" onClick={(e) => { that.DisableSync(e) }} disabled >OK</a>
        });
        var addResult = CommandService.AddCommandCleanDB(DeviceID, DeviceSerialNumber, CommandType, Pending, Result, Settled, PARAM1, PARAM2, PARAM3, CompanyCode, email);
        addResult.then(function (data) {
            if (data.data === "OK") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { that.CleanDB(e) }} >OK</a>
                });
                that.getCompanyDeviceData();
                toast.success("DB Cleaned Successfully!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "No") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { that.CleanDB(e) }} >OK</a>
                });
                that.getCompanyDeviceData();
                toast.error("Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "AuditError") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { that.CleanDB(e) }} >OK</a>
                });
                that.getCompanyDeviceData();
                toast.error("Audit Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch((error) => {
            that.setState({
                modal: {
                    warning: false, id: null, adjustSensors: {
                        active: false,
                        deviceId: null,
                        companyCode: null,
                        sensors: {
                            Pin: { selected: false, code: 1 },
                            Card: { selected: false, code: 2 },
                            Fingerprint: { selected: false, code: 3 }
                        }
                    }
                },
                loading: false,
                Button: <a className="btn btn-warning" onClick={(e) => { that.DisableSync(e) }} >OK</a>
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    that.setState({ isAutenticated: false },
                        () => {
                            that.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    AdjustSensors = (e) => {
        let stateData = this.state.modal.adjustSensors;
        let sensors = [];
        Object.keys(stateData.sensors).forEach(elem => {
            if (stateData.sensors[elem].selected)
                sensors.push(stateData.sensors[elem].code);
        });

        let email = sessionStorage.getItem('email');
        var data = {
            DeviceSerialNumber: stateData.deviceId,
            CompanyCode: stateData.companyCode,
            Email: email,
            SensorsSelected: sensors.join(',')
        };

        let that = this
        CommandService.AdjustSensors(data).then(dataResult => {
            if (dataResult.status === 200) {

                that.setState({
                    modal: {
                        warning: false, id: null, success: false, info: false, info2: false,
                        adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },

                });
                that.getCompanyDeviceData();
                toast.success("Device sensors adjusted !!!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch(error => {
            that.setState({
                modal: {
                    warning: false, id: null, success: false, info: false, info2: false, adjustSensors: {
                        active: false,
                        deviceId: null,
                        companyCode: null,
                        sensors: {
                            Pin: { selected: false, code: 1 },
                            Card: { selected: false, code: 2 },
                            Fingerprint: { selected: false, code: 3 }
                        }
                    }
                },

            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    that.setState({ isAutenticated: false },
                        () => {
                            that.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        })
    }
    ResendTimelog(e, id, CompanyCode) {

        let StartDate = this.state.Filter.Filterstartdate;
        let EndDate = this.state.Filter.Filterenddate;
        if (StartDate === null || StartDate === undefined || StartDate === "" || EndDate === undefined || EndDate === null || EndDate === "") {

            toast.error("Start Date and End Date are required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        var newStartDate = new Date(StartDate);
        var newendDate = new Date(EndDate);
        var StartDayPlus = newStartDate.setDate(newStartDate.getDate() + 6);
        var EndDatePlus = newendDate.setDate(newendDate.getDate());

        if (EndDatePlus >= StartDayPlus) {
            toast.error("No more than 6 days between Start and End!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }

        var email = sessionStorage.getItem('email');
        var DeviceSerialNumber = id;
        var DeviceID = 0;
        var CommandType = 323;
        var Pending = 1;
        var Result = null;
        let Settled = null;
        var PARAM1 = null;
        var PARAM2 = null;
        var PARAM3 = `${ StartDate }-T00:00:00,${ EndDate }-T23:59:59"`;

        var that = this;
        this.setState({
            loading: true,
            Button: <a className="btn btn-success disabled" onClick={(e) => { that.ResendTimelog(e) }} disabled >OK</a>
        });
        var addResult = CommandService.AddCommandCleanDB(DeviceID, DeviceSerialNumber, CommandType, Pending, Result, Settled, PARAM1, PARAM2, PARAM3, CompanyCode, email);
        addResult.then(function (data) {

            if (data.data === "OK") {
                that.setState({
                    modal: {
                        warning: false, id: null, resend: false, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-success" onClick={(e) => { that.ResendTimelog(e) }} >OK</a>,
                    Filter: { Filterstartdate: "", Filterenddate: "", FilterCompanyCode: that.state.Filter.FilterCompanyCode, FilterDeviceSerialNumber: that.state.Filter.FilterDeviceSerialNumber }
                });
                that.getCompanyDeviceData();
                toast.success("Command Send Successfully!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "No") {
                that.setState({
                    modal: {
                        warning: false, id: null, resend: false, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-success" onClick={(e) => { that.ResendTimelog(e) }} >OK</a>,
                    Filter: { Filterstartdate: "", Filterenddate: "", FilterCompanyCode: that.state.Filter.FilterCompanyCode, FilterDeviceSerialNumber: that.state.Filter.FilterDeviceSerialNumber }
                });
                that.getCompanyDeviceData();
                toast.error("Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "AuditError") {
                that.setState({
                    modal: {
                        warning: false, id: null, resend: false, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-success" onClick={(e) => { this.ResendTimelog(e) }} >OK</a>,
                    Filter: { Filterstartdate: "", Filterenddate: "", FilterCompanyCode: that.state.Filter.FilterCompanyCode, FilterDeviceSerialNumber: that.state.Filter.FilterDeviceSerialNumber }
                });
                that.getCompanyDeviceDatasdfsdf();
                toast.error("Audit Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch((error) => {
            that.setState({
                modal: {
                    warning: false, id: null, resend: false, adjustSensors: {
                        active: false,
                        deviceId: null,
                        companyCode: null,
                        sensors: {
                            Pin: { selected: false, code: 1 },
                            Card: { selected: false, code: 2 },
                            Fingerprint: { selected: false, code: 3 }
                        }
                    }
                },
                loading: false,
                Button: <a className="btn btn-success" onClick={(e) => { this.ResendTimelog(e) }} >OK</a>,
                Filter: {
                    Filterstartdate: "", Filterenddate: "", FilterCompanyCode: that.state.Filter.FilterCompanyCode,
                    FilterDeviceSerialNumber: that.state.Filter.FilterDeviceSerialNumber
                }
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {

                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }

        });
    }
    UpdateAPP(e, id, CompanyCode) {

        let newstartDate = new Date();
        let startdate = newstartDate.getFullYear() + "-" + (newstartDate.getMonth() + 1) + "-" + newstartDate.getDate();
        let DeviceID = 0;
        let DeviceSerialNumber = id;
        let CommandType = 200002;
        let Pending = 1;
        let Result = null;
        let Settled = startdate;
        var email = sessionStorage.getItem('email');
        var VersionTypeList = this.state.TypeList;
        var VersionNameV = this.state.SelectVersionName;
        var VersionTypeResult = this.state.SelectType;
        var VersionName = this.state.SelectVersionName;
        var VersionNameResult = VersionName;

        if (VersionTypeList === "" || VersionTypeList === undefined || VersionTypeList === null) {
            toast.warning("Type Field cant not be Empty!!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        if (VersionNameV === "" || VersionNameV === undefined || VersionNameV === null) {
            toast.warning("Version Field cant not be Empty!!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        this.setState({
            CompanyDevice: { CompanyDevicePending: true, CompanyDeviceData: [] },
            modal: {
                warning: false, id: null, adjustSensors: {
                    active: false,
                    deviceId: null,
                    companyCode: null,
                    sensors: {
                        Pin: { selected: false, code: 1 },
                        Card: { selected: false, code: 2 },
                        Fingerprint: { selected: false, code: 3 }
                    }
                }
            },
        });
        var that = this;
        var addResult = CommandService.AddCommandPendingUpdate(DeviceID, DeviceSerialNumber, CommandType, Pending, Result, Settled, CompanyCode, VersionTypeResult, VersionNameResult, email);
        addResult.then(function (data) {
            if (data.data === "OK") {
                that.setState({
                    Button: <a className="btn btn-warning" onClick={(e) => { that.EmptyUser(e) }}  >OK</a>,
                    loading: false,
                    CompanyDevice: { CompanyDevicePending: false, CompanyDeviceData: that.state.CompanyDevice.CompanyDeviceData },
                });
                that.getCompanyDeviceData();
                toast.success("Command Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "No") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { that.EmptyUser(e) }}  >OK</a>,
                    CompanyDevice: { CompanyDevicePending: false, CompanyDeviceData: that.state.CompanyDevice.CompanyDeviceData },
                });
                that.getCompanyDeviceData();
                toast.error("Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "AuditError") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { that.EmptyUser(e) }}  >OK</a>,
                    CompanyDevice: { CompanyDevicePending: false, CompanyDeviceData: that.state.CompanyDevice.CompanyDeviceData },
                });
                that.getCompanyDeviceData();
                toast.error("Audit Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch((error) => {
            that.setState({
                modal: {
                    warning: false, id: null, adjustSensors: {
                        active: false,
                        deviceId: null,
                        companyCode: null,
                        sensors: {
                            Pin: { selected: false, code: 1 },
                            Card: { selected: false, code: 2 },
                            Fingerprint: { selected: false, code: 3 }
                        }
                    }
                },
                loading: false,
                Button: <a className="btn btn-warning" onClick={(e) => { that.EmptyUser(e) }}  >OK</a>,
                CompanyDevice: { CompanyDevicePending: false, CompanyDeviceData: that.state.CompanyDevice.CompanyDeviceData },
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    that.setState({ isAutenticated: false },
                        () => {
                            that.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    UpdateModules(e, id, CompanyCode) {

        let newstartDate = new Date();
        let startdate = newstartDate.getFullYear() + "-" + (newstartDate.getMonth() + 1) + "-" + newstartDate.getDate();
        let DeviceID = 0;
        let DeviceSerialNumber = id;
        let CommandType = 200003;
        let Pending = 1;
        let Result = null;
        let Settled = startdate;
        var email = sessionStorage.getItem('email');
        var VersionTypeList = this.state.TypeList;
        var VersionNameV = this.state.SelectVersionName;
        var VersionTypeResult = this.state.SelectType;
        var VersionNameResult = this.state.SelectVersionName;

        if (VersionTypeList === "" || VersionTypeList === undefined || VersionTypeList === null) {
            toast.warning("Type Field cant not be Empty!!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        if (VersionNameV === "" || VersionNameV === undefined || VersionNameV === null) {
            toast.warning("Version Field cant not be Empty!!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        this.setState({
            CompanyDevice: { CompanyDevicePending: true, CompanyDeviceData: [] },
            modal: {
                warning: false, id: null, adjustSensors: {
                    active: false,
                    deviceId: null,
                    companyCode: null,
                    sensors: {
                        Pin: { selected: false, code: 1 },
                        Card: { selected: false, code: 2 },
                        Fingerprint: { selected: false, code: 3 }
                    }
                }
            },
        });
        var that = this;
        var addResult = CommandService.AddCommandPendingUpdate(DeviceID, DeviceSerialNumber, CommandType, Pending, Result, Settled, CompanyCode, VersionTypeResult, VersionNameResult, email);
        addResult.then(function (data) {
            if (data.data === "OK") {
                that.setState({
                    Button: <a className="btn btn-warning" onClick={(e) => { that.EmptyUser(e) }}  >OK</a>,
                    CompanyDevice: { CompanyDevicePending: false, CompanyDeviceData: that.state.CompanyDevice.CompanyDeviceData },
                });
                that.getCompanyDeviceData();
                toast.success("Command Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "No") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { that.EmptyUser(e) }}  >OK</a>,
                    CompanyDevice: { CompanyDevicePending: false, CompanyDeviceData: that.state.CompanyDevice.CompanyDeviceData },
                });
                that.getCompanyDeviceData();
                toast.error("Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "AuditError") {
                that.setState({
                    modal: {
                        warning: false, id: null, adjustSensors: {
                            active: false,
                            deviceId: null,
                            companyCode: null,
                            sensors: {
                                Pin: { selected: false, code: 1 },
                                Card: { selected: false, code: 2 },
                                Fingerprint: { selected: false, code: 3 }
                            }
                        }
                    },
                    loading: false,
                    Button: <a className="btn btn-warning" onClick={(e) => { that.EmptyUser(e) }}  >OK</a>,
                    CompanyDevice: { CompanyDevicePending: false, CompanyDeviceData: that.state.CompanyDevice.CompanyDeviceData },
                });
                that.getCompanyDeviceData();
                toast.error("Audit Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch((error) => {
            that.setState({
                modal: {
                    warning: false, id: null, adjustSensors: {
                        active: false,
                        deviceId: null,
                        companyCode: null,
                        sensors: {
                            Pin: { selected: false, code: 1 },
                            Card: { selected: false, code: 2 },
                            Fingerprint: { selected: false, code: 3 }
                        }
                    }
                },
                loading: false,
                Button: <a className="btn btn-warning" onClick={(e) => { that.EmptyUser(e) }}  >OK</a>,
                CompanyDevice: { CompanyDevicePending: false, CompanyDeviceData: that.state.CompanyDevice.CompanyDeviceData },
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    getCommandPendindByDeviceAll(CompanyCode, DeviceSerialNumber) {

        var that = this;
        var Email = sessionStorage.getItem('email');
        var DataResult = CommandService.getCommandPendindByDevice(CompanyCode, DeviceSerialNumber, Email);
        DataResult.then(function (data) {
            if (data.statusText === "OK") {
                that.setState({
                    loading: false,
                    CommandTypeList: data.data,
                });
            }
        }).catch((error) => {
            that.setState({
                loading: false,
                CommandTypeList: [],
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    that.setState({ isAutenticated: false },
                        () => {
                            that.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    DeleteCommandPendingByDevice(DeviceSerialNumber, CompanyCode, CommandType) {

        var that = this;
        var Email = sessionStorage.getItem('email');

        that.setState({
            loading: true
        });
        var DataResult = CommandService.DeleteCommandPendingDevicebyCommandType(DeviceSerialNumber, CompanyCode, CommandType, Email);
        DataResult.then(function (data) {
            if (data.statusText === "OK") {
                that.setState({
                    loading: false,
                });
                toast.success("Deleted!", {
                    className: {
                        opacity: 0.8
                    }
                });
                that.getCommandPendindByDeviceAll(CompanyCode, DeviceSerialNumber)
                that.getCompanyDeviceData();
            }
        }).catch((error) => {
            that.setState({
                loading: false,
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    that.setState({ isAutenticated: false },
                        () => {
                            that.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    renderRealtimeRow1() {

        let dataResult = RolesType;
        var temp = Object.keys(dataResult);
        if (sessionStorage.getItem("rol") === temp[0] || sessionStorage.getItem("rol") === temp[1]) {
            return <div>
                <div className="row" >
                    {
                        this.renderRealtimeRow21()
                    }
                </div><br />
            </div>
        }
    }
    renderRealtimeRow21() {

        let dataResult = RolesType;

        var temp = Object.keys(dataResult);

        if (sessionStorage.getItem("rol") === temp[0] || sessionStorage.getItem("rol") === temp[1]) {
            return <div className="col-12" >
                <div className="card Logs" >
                    <div className="card-body" >
                        <Container >
                            <div className="row">
                                <div className="col-2">
                                    <h4><span className="badge badge-info">Company Taks</span></h4>
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <div style={{ 'paddingTop': '15px', 'width': 'auto' }}><label style={{ 'fontWeight': 'bold' }}>Company Code</label>  </div>
                                <div className="col-3" style={{ 'paddingTop': '10px', 'width': 'auto' }}>
                                    <input className="form-control" name="companycodeTask" id="companycodeTask" type="text" value={this.state.SelectCompanyCode} onChange={this.companyCodeSelectValue} />
                                </div>
                                <div className="form-group" style={{ paddingTop: 4 }}>
                                    {
                                        this.state.Punchloading
                                            ?
                                            <div>
                                                <ClipLoader
                                                    className={override}
                                                    sizeUnit={"px"}
                                                    size={30}
                                                    color={'#FF3547'}
                                                    loading={this.state.Punchloading}
                                                />
                                                <a className="btn btn-danger disabled" style={{ 'padding': '0.6rem 1.14rem' }} onClick={(e) => this.DeleteRepeatedPunches(e)} disabled><FontAwesomeIcon icon={faTrash} /> &nbsp;Remove Duplicated Punch</a>
                                            </div>
                                            :
                                            <div>
                                                <a className="btn btn-danger" style={{ 'padding': '0.6rem 1.14rem' }} onClick={(e) => this.DeleteRepeatedPunches(e)}><FontAwesomeIcon icon={faTrash} /> &nbsp;Remove Duplicated Punch</a>
                                            </div>

                                    }

                                </div>
                            </div>
                        </Container>
                    </div>
                </div>
            </div>
        }
    }
    renderTab1() {
        let dataResultCommandType = CommandType;
        var List = this.state.CommandTypeDetailsList;
        return <div style={{ height: '350px', overflowY: "scroll" }}>
            <table className="table table-hover table-striped table-lg">
                <thead >
                    <tr>
                        <th scope="col-sm" style={{ 'fontWeight': 'bold' }}>Command Type</th>
                        <th scope="col-sm" style={{ 'fontWeight': 'bold' }}>Command Name</th>
                        <th scope="col-sm" style={{ 'fontWeight': 'bold' }}>Param1</th>
                        <th scope="col-sm" style={{ 'fontWeight': 'bold' }}>Param2</th>
                        <th scope="col-sm" style={{ 'fontWeight': 'bold' }}>Param3</th>
                    </tr>
                </thead>
                {
                    this.state.loading
                        ? <tbody className="loader"></tbody>
                        :
                        List.length > 0
                            ?
                            List.map((item, index) => {
                                return <tbody key={index}>
                                    <tr key={index} >
                                        <td style={{ 'fontWeight': '400' }}>{item.COMMAND_TYPE}</td>
                                        <td style={{ 'fontWeight': '400' }}>{Object.keys(dataResultCommandType).find(x => parseInt(dataResultCommandType[x], 10) === parseInt(item.COMMAND_TYPE, 10))}</td>
                                        <td style={{ 'fontWeight': '400' }}>{item.PARAM1}</td>
                                        <td style={{ 'fontWeight': '400' }}>{item.PARAM2}</td>
                                        <td style={{ 'fontWeight': '400', textAlign: "left" }}>{item.PARAM3}</td>
                                    </tr>
                                </tbody>;
                            })
                            :
                            <tbody><tr><td colSpan="7" align="center" style={{ 'fontWeight': '400', 'padding': '0 !important' }}>There are no records</td></tr></tbody>
                }
            </table>
        </div>
    }
    renderTab2() {

        var List = this.state.CommandTypeDetailsRestriction;
        return <table className="table table-hover table-striped table-lg">
            <thead >
                <tr>
                    <th scope="col-sm" style={{ 'fontWeight': 'bold' }}>Reason</th>
                    <th scope="col-sm" style={{ 'fontWeight': 'bold' }}>Start Date</th>
                    <th scope="col-sm" style={{ 'fontWeight': 'bold' }}>Expire Time</th>
                    <th scope="col-sm" style={{ 'fontWeight': 'bold' }}>Failures</th>
                    <th scope="col-sm" style={{ 'fontWeight': 'bold' }}></th>
                </tr>
            </thead>
            {
                List
                    ?
                    <tbody>
                        <tr>
                            <td style={{ 'fontWeight': '400' }}>{List.Reason}</td>
                            <td style={{ 'fontWeight': '400' }}>{List.StartDateTime}</td>
                            <td style={{ 'fontWeight': '400' }}>{List.ExpireTime}</td>
                            <td style={{ 'fontWeight': '400' }}>{List.Failures}</td>
                            <td style={{ 'fontWeight': '400' }}>
                                <Button style={{ 'padding': '0.1rem 0.6rem', 'fontSize': '0.70rem' }} size="sm" onClick={(e) => this.setOperation(e, List.DeviceSerialNumber, List.CompanyCode, 'DEL')} color="danger" tag="a"><FontAwesomeIcon icon={faTrash} /></Button>
                            </td>
                        </tr>
                    </tbody>

                    :
                    <tbody>
                        <tr>
                            <td colSpan="5" style={{ 'fontWeight': '400' }}>There are no records</td>
                        </tr>
                    </tbody>
            }

        </table>
    }

    renderTab3() {

        let optionItemsTypes = this.state.TypeList.map((item, index) => {
            return <option key={item.ID} className="dropdown-item" href="#" value={item.ID}>{item.Name}</option>
        });

        let optionItemsVersionName = this.state.VersionNameList.map((item, index) => {
            return <option key={item.ID} className="dropdown-item" href="#" value={item.ID}>{item.Name}</option>
        });

        var List = this.state.CommandTypeDetailsList;
        var CompanyCode = this.state.ViewCompanyCode;
        var DeviceSerialNumber = this.state.DeviceSerialNumber;
        var UpdateAppResult = List.find(x => x.DeviceSerialNumber === DeviceSerialNumber && x.COMMAND_TYPE === "200002");
        var UpdateModuleResult = List.find(x => x.DeviceSerialNumber === DeviceSerialNumber && x.COMMAND_TYPE === "200003");

        return <div>
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12">
                    {/* <Alert color="info">Send Command Pending(Update APP or Update Modules)</Alert> */}
                </div>
            </div>
            <div className="row" style={{ 'paddingTop': '50px' }}>
                <div className="col-lg-1 col-md-1 col-sm-1">
                    <label className="control-label" style={{ 'paddingTop': '10px', 'fontWeight': 'bold' }}>Type</label>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4">
                    <select className="form-control" onChange={this.handleChangeVersion} value={this.state.SelectType} >
                        <option className="dropdown-item" href="#" value="" >Select</option>
                        {optionItemsTypes}
                    </select>
                </div>
                <div className="col-lg-2 col-md-2 col-sm-2">
                    <label className="control-label" style={{ 'paddingTop': '10px', 'fontWeight': 'bold' }}>Version</label>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4">
                    <select className="form-control" onChange={this.handleChangeVersionName} value={this.state.SelectVersionName} >
                        <option className="dropdown-item" href="#" value="" >Select</option>
                        {optionItemsVersionName}
                    </select>
                </div>
            </div>
            <div className="row" style={{ 'paddingTop': '80px' }}>
                <div className="col-4 offset-2" >
                    <Button color="primary" disabled={UpdateAppResult !== undefined} onClick={(e) => { this.UpdateAPP(e, DeviceSerialNumber, CompanyCode) }}>Update APP</Button>
                </div>
                <div className="col-4" >
                    <Button color="primary" disabled={UpdateModuleResult !== undefined} onClick={(e) => { this.UpdateModules(e, DeviceSerialNumber, CompanyCode) }}>Update Modules</Button>
                </div>
            </div>
        </div>
    }
    getMessageResult(type) {
        if (type === 1)
            return <div style={{ color: "#4285F4" }}><strong>Pending</strong></div>;
        else if (type === 2)
            return <div style={{ color: "green" }}><strong>Success</strong></div>;
        else if (type === 3)
            return <div style={{ color: "red" }}><strong>Error</strong></div>;
        else if (type === 4)
            return <div style={{ color: "#FF8800" }}><strong>Invalid</strong></div>;
        else if (type === 5)
            return <div style={{ color: "#212544" }}><strong>NotReady</strong></div>;
        else if (type === 6)
            return <div style={{ color: "#212536" }}><strong>UnKnown</strong></div>;
        else if (type === 7)
            return <div style={{ color: "#3F51B5" }}><strong>Streaming</strong></div>;
        else
            return "";
    }

    renderRealtimeRow2() {
        const formatDate = (date) => {
            const process2placess = (value) => {
                return value < 10 ? '0' + value : value;
            }

            let year = process2placess(date.getFullYear());
            if (parseInt(year) < 2000) {
                return '-';
            }

            let month = process2placess(date.getMonth() + 1);
            let day = process2placess(date.getDate());

            let hours = process2placess(date.getHours());
            let minutes = process2placess(date.getMinutes());
            let seconds = process2placess(date.getSeconds());



            return `${ month }-${ day }-${ year } ${ hours }:${ minutes }:${ seconds }`
        }
        let dataResult = RolesType;
        var temp = Object.keys(dataResult);

        if (sessionStorage.getItem("rol") === temp[0] || sessionStorage.getItem("rol") === temp[1] || sessionStorage.getItem("rol") === temp[2] || sessionStorage.getItem("rol") === temp[4] ||
            sessionStorage.getItem("rol") === temp[5]) {
            return <div>
                <div className="row">
                    <div className="col-12" >
                        <div className="card Logs">
                            <div className="card-header">
                                <div className="row" id="timelogs_filter">
                                    <div className="col-sm">
                                        <label className="control-label" style={{ 'fontWeight': 'bold' }}>Company Code</label>
                                        <div className="form-group">
                                            <input className="form-control" name="companycode" id="companycode" type="text" onKeyDown={this.hanldeKeyPress} onChange={this.companyCodeValue} value={this.state.Filter.FilterCompanyCode} />
                                        </div>
                                    </div>
                                    <div className="col-sm">
                                        <label className="control-label" style={{ 'fontWeight': 'bold' }}>Serial Number</label>
                                        <div className="form-group">
                                            <input type="text" name="loglevel" id="loglevel" className="form-control" onKeyDown={this.hanldeKeyPress} onChange={this.serialNumberValue} value={this.state.Filter.FilterDeviceSerialNumber} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body divCardRealtime table-responsive-md" style={{ 'overflowY': 'scroll' }}>
                                <table className="table table-hover table-striped  table-sm">
                                    <thead >
                                        <tr>
                                            <th scope="col"></th>
                                            <th scope="col"></th>
                                            <th scope="col" style={{ 'fontWeight': 'bold' }}>Serial Number</th>
                                            <th scope="col" style={{ 'fontWeight': 'bold' }}>Company Code</th>
                                            <th scope="col" style={{ 'fontWeight': 'bold' }}>Pennding Command(Total)</th>
                                            <th scope="col" style={{ 'fontWeight': 'bold' }}>Access Control</th>
                                            <th scope="col" style={{ 'fontWeight': 'bold' }}>Last Connected</th>
                                            <th scope="col" style={{ 'fontWeight': 'bold' }}>Last Disconnected</th>
                                            <th scope="col" style={{ 'fontWeight': 'bold' }}>Last App Update Command</th>
                                            <th scope="col" style={{ 'fontWeight': 'bold' }}>Result(App)</th>
                                            <th scope="col" style={{ 'fontWeight': 'bold' }}>Last Module Update Command</th>
                                            <th scope="col" style={{ 'fontWeight': 'bold' }}>Result(Module)</th>
                                            <th scope="col" style={{ 'fontWeight': 'bold' }}>Actions&nbsp;&nbsp;&nbsp;</th>
                                        </tr>
                                    </thead>
                                    {
                                        this.state.CompanyDevice.CompanyDeviceData.length > 0 && this.state.CompanyDevice.CompanyDevicePending === false
                                            ?
                                            this.state.CompanyDevice.CompanyDeviceData.map((item, index) => {
                                                let lastConnected = item.LastConnected ? formatDate(new Date(item.LastConnected)) : "";
                                                let lastDisconnected = item.LastDisconnected ? formatDate(new Date(item.LastDisconnected)) : "";
                                                return [<tbody key={index}>
                                                    <tr key={index}>
                                                        <td><FontAwesomeIcon icon={!!this.state.collapsedMenus["#demo1" + item.id] ? faChevronUp : faChevronDown} data-toggle="collapse" data-target={"#demo1" + item.id} style={{ cursor: 'pointer' }} className="accordion-toggle" aria-expanded={!!this.state.collapsedMenus["#demo1" + item.id]} aria-controls={"#demo1" + item.id} onClick={e => {
                                                            this.setState(state => {
                                                                let newState = {
                                                                    ...state
                                                                };
                                                                newState.collapsedMenus["#demo1" + item.id] = !newState.collapsedMenus["#demo1" + item.id];
                                                                return newState;
                                                            }, () => { console.log('chevron updated') })
                                                        }} /></td>
                                                        <td style={{ 'fontWeight': 'normal' }}>{item.Status}</td>
                                                        <td style={{ 'fontWeight': 'normal' }}>{item.DeviceSerialNumber}</td>
                                                        <td style={{ 'fontWeight': 'normal' }}>{item.CompanyCode}</td>
                                                        <td style={{ 'fontWeight': 'normal' }}>{item.Pending}</td>
                                                        <td style={{ 'fontWeight': 'normal' }}>{item.AccessControl === true ? <FontAwesomeIcon style={{ color: "green" }} icon={faCheck} /> : <FontAwesomeIcon style={{ color: "red" }} icon={faTimes} />}</td>
                                                        <td style={{ 'fontWeight': 'normal' }}>{lastConnected}</td>
                                                        <td style={{ 'fontWeight': 'normal' }}>{lastDisconnected}</td>
                                                        <td style={{ 'fontWeight': 'normal' }}>{this.state.DataCommandList.length > 0 && this.state.DataCommandList.find(x => x.DeviceSerialNumber === item.DeviceSerialNumber && x.CommandType === 200002) !== undefined ? this.state.DataCommandList.find(x => x.DeviceSerialNumber === item.DeviceSerialNumber && x.CommandType === 200002).Settled.replace("T", " ") : ""}</td>
                                                        <td style={{ 'fontWeight': 'normal' }}>{this.state.DataCommandList.length > 0 && this.state.DataCommandList.find(x => x.DeviceSerialNumber === item.DeviceSerialNumber && x.CommandType === 200002) !== undefined ? this.getMessageResult(this.state.DataCommandList.find(x => x.DeviceSerialNumber === item.DeviceSerialNumber && x.CommandType === 200002).Result) : ""}</td>
                                                        <td style={{ 'fontWeight': 'normal' }}>{this.state.DataCommandList.length > 0 && this.state.DataCommandList.find(x => x.DeviceSerialNumber === item.DeviceSerialNumber && x.CommandType === 200003) !== undefined ? this.state.DataCommandList.find(x => x.DeviceSerialNumber === item.DeviceSerialNumber && x.CommandType === 200003).Settled.replace("T", " ") : ""}</td>
                                                        <td style={{ 'fontWeight': 'normal' }}>{this.state.DataCommandList.length > 0 && this.state.DataCommandList.find(x => x.DeviceSerialNumber === item.DeviceSerialNumber && x.CommandType === 200003) !== undefined ? this.getMessageResult(this.state.DataCommandList.find(x => x.DeviceSerialNumber === item.DeviceSerialNumber && x.CommandType === 200003).Result) : ""}</td>
                                                        <td>

                                                            <Button style={{ 'padding': '0.1rem 0.6rem', 'fontSize': '0.70rem' }} size="sm" onClick={(e) => this.setOperation(e, item.DeviceSerialNumber, item.CompanyCode, 'VIEW')} color="warning" tag="a"><FontAwesomeIcon icon={faEye} /></Button>&nbsp;&nbsp;
                                                        <Button style={{ 'padding': '0.1rem 0.6rem', 'fontSize': '0.70rem' }} size="sm" onClick={(e) => this.setOperation(e, item.DeviceSerialNumber, item.CompanyCode, 'DELALL')} color="danger" tag="a"><FontAwesomeIcon icon={faInfo} /></Button>

                                                        </td>
                                                    </tr>
                                                </tbody>,
                                                <tbody id={"demo1" + item.id} className="collapse" key={"2" + index}>
                                                    <tr className="hiddenRow" key={"tr2" + index}>
                                                        <td colSpan="14" className="hiddenRow" key={"td2" + index}>
                                                            <Button style={{ 'padding': '0.1rem 0.6rem', 'fontSize': '0.70rem' }} size="sm" onClick={(e) => this.setOperation(e, item.DeviceSerialNumber, item.CompanyCode, 'ADD')} color="info" tag="a"><FontAwesomeIcon icon={faClock} />&nbsp;&nbsp;Sync. Time</Button>&nbsp;&nbsp;
                                                        <Button style={{ 'padding': '0.1rem 0.6rem', 'fontSize': '0.70rem' }} size="sm" onClick={(e) => this.setOperation(e, item.DeviceSerialNumber, item.CompanyCode, 'DELETE')} color="danger" tag="a"><FontAwesomeIcon icon={faTrash} />&nbsp;&nbsp;Delete Pending Command</Button>&nbsp;&nbsp;
                                                        <Button style={{ 'padding': '0.1rem 0.6rem', 'fontSize': '0.70rem' }} size="sm" onClick={(e) => this.setOperation(e, item.DeviceSerialNumber, item.CompanyCode, 'Empty_User')} color="danger" tag="a"><FontAwesomeIcon icon={faUserTimes} />&nbsp;&nbsp;Empty Users</Button>&nbsp;&nbsp;
                                                        <Button style={{ 'padding': '0.1rem 0.6rem', 'fontSize': '0.70rem' }} size="sm" onClick={(e) => this.setOperation(e, item.DeviceSerialNumber, item.CompanyCode, 'Take_Managers')} color="warning" tag="a"><FontAwesomeIcon icon={faUserSecret} />&nbsp;&nbsp;Take off Managers</Button>&nbsp;&nbsp;
                                                        <Button style={{ 'padding': '0.1rem 0.6rem', 'fontSize': '0.70rem' }} size="sm" onClick={(e) => this.setOperation(e, item.DeviceSerialNumber, item.CompanyCode, 'Clean_Cache')} color="danger" tag="a"><FontAwesomeIcon icon={faTrash} />&nbsp;&nbsp;Clean Cache</Button>&nbsp;&nbsp;
                                                        <Button style={{ 'padding': '0.1rem 0.6rem', 'fontSize': '0.70rem' }} size="sm" onClick={(e) => this.setOperation(e, item.DeviceSerialNumber, item.CompanyCode, 'Clean_Restriction')} color="danger" tag="a"><FontAwesomeIcon icon={faTrash} />&nbsp;&nbsp;Clean Restriction</Button>&nbsp;&nbsp;
                                                        <Button style={{ 'padding': '0.1rem 0.6rem', 'fontSize': '0.70rem' }} size="sm" onClick={(e) => this.setOperation(e, item.DeviceSerialNumber, item.CompanyCode, 'Enable_Sync')} color="success" tag="a"><FontAwesomeIcon icon={faCheck} />&nbsp;&nbsp;Enable Sync.</Button>&nbsp;&nbsp;
                                                        <Button style={{ 'padding': '0.1rem 0.6rem', 'fontSize': '0.70rem' }} size="sm" onClick={(e) => this.setOperation(e, item.DeviceSerialNumber, item.CompanyCode, 'Disable_Sync')} color="danger" tag="a"><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Disable Sync.</Button>&nbsp;&nbsp;
                                                        <Button style={{ 'padding': '0.1rem 0.6rem', 'fontSize': '0.70rem' }} size="sm" onClick={(e) => this.setOperation(e, item.DeviceSerialNumber, item.CompanyCode, 'Clean_DB')} color="danger" tag="a"><FontAwesomeIcon icon={faTrash} />&nbsp;&nbsp;Clean DB.</Button>&nbsp;&nbsp;
                                                        <Button style={{ 'padding': '0.1rem 0.6rem', 'fontSize': '0.70rem' }} size="sm" onClick={(e) => this.setOperation(e, item.DeviceSerialNumber, item.CompanyCode, 'Resend_Timelog')} color="info" tag="a"><FontAwesomeIcon icon={faCircleNotch} />&nbsp;&nbsp;Resend Timelog</Button>&nbsp;&nbsp;
                                                        <Button style={{ 'padding': '0.1rem 0.6rem', 'fontSize': '0.70rem' }} size="sm" onClick={(e) => this.setOperation(e, item.DeviceSerialNumber, item.CompanyCode, 'ADJUST_SENSORS')} color="success" tag="a"><FontAwesomeIcon icon={faAdjust} />&nbsp;&nbsp;Adjust sensors</Button>&nbsp;&nbsp;
                                                    </td>
                                                    </tr>
                                                </tbody>]
                                            })
                                            :
                                            this.state.CompanyDevice.CompanyDeviceData.length === 0 && this.state.CompanyDevice.CompanyDevicePending === false
                                            &&
                                            <tbody><tr><td colSpan="13"><div style={{ 'textAlign': 'center', 'fontWeight': 'normal' }}>No records.</div></td></tr></tbody>
                                    }

                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
    }
    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    render() {

        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'} />)
        }

        let state = this.state;

        return (<div id="">
            <BlockUi tag="div" blocking={this.state.CompanyDevice.CompanyDevicePending} loader={<div className="loader"></div>} >
                <MainLayout />
                <ToastContainer hideProgressBar />
                <div className="container-fluid" >
                    <div className="row">
                        <div className="col-12">
                            {this.renderRealtimeRow2()}
                        </div>
                        {/* <div className="col-6">
                        {this.renderRealtimeRow1()}
                    </div> */}
                    </div>
                </div>

                <Modal isOpen={this.state.modal.warning} toggle={this.toggleWarning}

                    aria-labelledby="contained-modal-title-lg"
                    className={"modal-dialog modal-notify modal-warning"}
                >
                    <ModalHeader toggle={this.toggle}> <p className="heading lead">Warning</p>
                    </ModalHeader>
                    <ModalBody className={"text-center"} style={{ 'maxHeight': 'calc(100vh - 210px)', 'overflowY': 'auto' }}>
                        <p><FontAwesomeIcon color="#FFBB33" icon={faExclamationTriangle} size="3x" /></p>
                        <p>Are you sure?</p>
                    </ModalBody>
                    <ModalFooter className={"modal-footer justify-content-right"}>
                        <ClipLoader
                            className={override}
                            sizeUnit={"px"}
                            size={30}
                            color={'#FF8800'}
                            loading={this.state.loading}
                        />
                        {this.state.Button}
                        {
                            this.state.loading
                                ? <a className="btn btn-outline-warning waves-effect disabled" onClick={this.toggleWarning} disabled>CLOSE</a>
                                : <a className="btn btn-outline-warning waves-effect" onClick={this.toggleWarning}>CLOSE</a>
                        }
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modal.resend} toggle={this.toggleResend}
                    aria-labelledby="contained-modal-title-lg"
                    className={"modal-dialog modal-notify modal-success"}
                >
                    <ModalHeader toggle={this.toggleResend}> <p className="heading lead">Resend Timelog</p>
                    </ModalHeader>
                    <ModalBody className={"text-center"} style={{ 'maxHeight': 'calc(100vh - 500px)' }}>
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-6">
                                <label className="control-label" style={{ 'fontWeight': '900' }}>Start Date</label>
                                <div className="form-group">
                                    <DayPickerInput
                                        onDayChange={day => this.getStartDate(day)}
                                        value={this.state.Filter.Filterstartdate ? this.state.Filter.Filterstartdate : ""}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6">
                                <label className="control-label" style={{ 'fontWeight': '900' }}>End Date</label>
                                <div className="form-group">
                                    <DayPickerInput
                                        onDayChange={day => this.getEndDate(day)}
                                        value={this.state.Filter.Filterenddate ? this.state.Filter.Filterenddate : ""}
                                    />
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter className={"modal-footer justify-content-right"}>
                        <ClipLoader
                            className={override}
                            sizeUnit={"px"}
                            size={30}
                            color={'#00C851'}
                            loading={this.state.loading}
                        />
                        {this.state.Button}
                        {
                            this.state.loading
                                ? <a className="btn btn-outline-success waves-effect disabled" onClick={this.toggleResend} disabled>CLOSE</a>
                                : <a className="btn btn-outline-success waves-effect" onClick={this.toggleResend}>CLOSE</a>
                        }
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.modal.info} toggle={this.toggleInfo}

                    aria-labelledby="contained-modal-title-lg"
                    className={"modal-dialog modal-notify modal-info"}
                >
                    <ModalHeader toggle={this.toggleInfo}> <p className="heading lead">View</p>
                    </ModalHeader>
                    <ModalBody className={"text-center"} style={{ 'maxHeight': '500px', 'overflowY': 'auto' }}>

                        <table className="table table-hover table-striped table-sm">
                            <thead >
                                <tr>
                                    <th scope="col-sm" style={{ 'fontWeight': 'bold' }}>Device Serial Number</th>
                                    <th scope="col-sm" style={{ 'fontWeight': 'bold' }}>Command Type</th>
                                    <th scope="col-sm" style={{ 'fontWeight': 'bold' }}>Total</th>
                                    <th scope="col-sm" style={{ 'fontWeight': 'bold' }}></th>
                                </tr>
                            </thead>
                            {
                                this.state.loading
                                    ? <tbody className="loader"></tbody>
                                    : this.state.CommandTypeList.length > 0
                                        ? this.state.CommandTypeList.map((item, index) => {
                                            return <tbody key={index}>
                                                <tr key={index} >
                                                    <td style={{ 'fontWeight': '400' }}>{item.DeviceSerialNumber}</td>
                                                    <td style={{ 'fontWeight': '400' }}>{item.COMMAND_TYPE}</td>
                                                    <td style={{ 'fontWeight': '400' }}>{item.TOTAL}</td>
                                                    <td>
                                                        {
                                                            item.TOTAL > 0
                                                            &&
                                                            <a style={{ 'paddingLeft': '10px', 'fontSize': '15px' }} onClick={(e) => this.DeleteCommandPendingByDevice(item.DeviceSerialNumber, item.CompanyCode, item.COMMAND_TYPE)}><Badge color="danger"><FontAwesomeIcon icon={faTrash} size="lg" /></Badge></a>
                                                        }
                                                    </td>
                                                </tr>
                                            </tbody>;
                                        })
                                        :
                                        <tbody>
                                            <tr>
                                                <td colSpan="4" style={{ 'fontWeight': '400' }}>No Data to Show</td>
                                            </tr>
                                        </tbody>
                            }
                        </table>

                    </ModalBody>
                    <ModalFooter className={"modal-footer justify-content-right"}>
                        {/* <ClipLoader
                   className={override}
                   sizeUnit={"px"}
                   size={30}
                   color={'#FF8800'}
                   loading={this.state.loading}
               /> */}
                        {
                            this.state.loading
                                ? <a className="btn btn-outline-info waves-effect disabled" onClick={this.toggleInfo} disabled>CLOSE</a>
                                : <a className="btn btn-outline-info waves-effect" onClick={this.toggleInfo}>CLOSE</a>
                        }
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.modal.info2} toggle={this.toggleInfo2}

                    aria-labelledby="contained-modal-title-lg"
                    className={"modal-dialog modal-notify modal-info"}
                    size="lg"
                >
                    <ModalHeader toggle={this.toggleInfo2}>
                        <div className="row">
                            <div className="col-12">
                                <span className="heading lead">{this.state.DeviceSerialNumber ? "Device: " + this.state.DeviceSerialNumber : "Device"}</span>
                            </div>
                        </div>

                    </ModalHeader>
                    <ModalBody className={"text-center"} style={{ 'maxHeight': '500px' }}>
                        {/* <Tabs className="myClass" onSelect={(index, label) => console.log(index + ' selected')}>
                        <Tab label="Pending Commands">{this.renderTab1()}</Tab>
                        <Tab label="Restrictions">{this.renderTab2()}</Tab>
                        <Tab label="Send Update APP/Modules">{this.renderTab3()}</Tab>
                    </Tabs> */}
                        <div>
                            <Nav tabs className="myClass">
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === '1' })}
                                        onClick={() => { this.toggle('1'); }}
                                    >
                                        Pending Commands
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === '2' })}
                                        onClick={() => { this.toggle('2'); }}
                                    >
                                        Restrictions
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === '3' })}
                                        onClick={() => { this.toggle('3'); }}
                                    >
                                        Send Update APP/Modules
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={this.state.activeTab}>
                                <TabPane tabId="1" className="myClass">
                                    <Row style={{ paddingTop: "20px" }}>
                                        <Col sm="12">
                                            <Card body>
                                                {this.renderTab1()}
                                            </Card>
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="2">
                                    <Row style={{ paddingTop: "20px" }}>
                                        <Col sm="12">
                                            <Card body>
                                                {this.renderTab2()}
                                            </Card>
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="3">
                                    <Row style={{ paddingTop: "20px" }}>
                                        <Col sm="12">
                                            <Card body>
                                                {this.renderTab3()}
                                            </Card>
                                        </Col>
                                    </Row>
                                </TabPane>
                            </TabContent>
                        </div>
                    </ModalBody>
                    <ModalFooter className={"modal-footer justify-content-right"}>
                        {/* <ClipLoader
                   className={override}
                   sizeUnit={"px"}
                   size={30}
                   color={'#FF8800'}
                   loading={this.state.loading}
               /> */}
                        {
                            this.state.loading
                                ? <a className="btn btn-outline-info waves-effect disabled" onClick={this.toggleInfo2} disabled>CLOSE</a>
                                : <a className="btn btn-outline-info waves-effect" onClick={this.toggleInfo2}>CLOSE</a>
                        }
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.modal.adjustSensors && this.state.modal.adjustSensors.active} toggle={this.toggleAdjustSensors}

                    aria-labelledby="contained-modal-title-lg"
                    className={"modal-dialog modal-notify modal-success"}
                >
                    <ModalHeader toggle={this.toggleAdjustSensors}> <p className="heading lead">Adjust sensors</p>
                    </ModalHeader>
                    <ModalBody className={"text-center"} style={{ 'maxHeight': 'calc(100vh - 210px)', 'overflowY': 'auto' }}>
                        <div className="form-check form-check-inline">
                            <label className={'form-check-label'}><input className="form-check-input" type="checkbox" onClick={(e) => this.setState(state => {
                                let stateCopy = { ...state };
                                stateCopy.modal.adjustSensors.sensors.Pin.selected = !stateCopy.modal.adjustSensors.sensors.Pin.selected;
                                return stateCopy;
                            })} checked={this.state.modal.adjustSensors.sensors.Pin.selected} />
                                Pin</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <label className={'form-check-label'}><input className="form-check-input" type="checkbox" onClick={(e) => this.setState(state => {
                                let stateCopy = { ...state };
                                stateCopy.modal.adjustSensors.sensors.Card.selected = !stateCopy.modal.adjustSensors.sensors.Card.selected;
                                return stateCopy;
                            })} checked={this.state.modal.adjustSensors.sensors.Card.selected} />
                                Card</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <label className={'form-check-label'}><input className="form-check-input" type="checkbox" onClick={(e) => this.setState(state => {
                                let stateCopy = { ...state };
                                stateCopy.modal.adjustSensors.sensors.Fingerprint.selected = !stateCopy.modal.adjustSensors.sensors.Fingerprint.selected;
                                return stateCopy;
                            })} checked={this.state.modal.adjustSensors.sensors.Fingerprint.selected} />
                                Fingerprint</label>
                        </div>
                        {/* <p><FontAwesomeIcon color="#FFBB33" icon={faExclamationTriangle} size="3x" /></p>
                        <p>Are you sure?</p> */}
                    </ModalBody>
                    <ModalFooter className={"modal-footer justify-content-right"}>
                        <ClipLoader
                            className={override}
                            sizeUnit={"px"}
                            size={30}
                            color={'#FF8800'}
                            loading={this.state.loading}
                        />
                        {this.state.Button}
                        {
                            this.state.loading
                                ? <a className="btn btn-outline-warning waves-effect disabled" onClick={this.toggleAdjustSensors} disabled>CLOSE</a>
                                : <a className="btn btn-outline-warning waves-effect" onClick={this.toggleAdjustSensors}>CLOSE</a>
                        }
                    </ModalFooter>
                </Modal>
            </BlockUi>

        </div>
        );
    }
}
export default RealTime;



// WEBPACK FOOTER //
// ./src/realtime/realtimeComponent.jsx